import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    offset: { type: String, default: "0px" },
    reveals: { type: Array, default: [] },
    featureFlag: { type: String, default: "" },
  }

  connect() {
    if (!this.featureFlagValue) {
      this.setupObserver()
      return
    }

    this.unsubscribeFeatureFlags = window.posthog.onFeatureFlags(() => {
      if (window.posthog.getFeatureFlag(this.featureFlagValue) === "test") {
        this.setupObserver()
      }
    })
  }

  setupObserver() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.reveals = this.revealsValue
          .map(([selector, className, invert]) => ({
            element: document.querySelector(selector),
            className,
            invert,
          }))
          .filter(({ element }) => element)
        for (const { element, className, invert } of this.reveals) {
          element.classList.toggle(className, invert ? !entry.isIntersecting : entry.isIntersecting)
        }
      },
      { rootMargin: `-${this.offsetValue} 0px 0px 0px`, threshold: 0 },
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    this.disconnected = true
    this.observer?.disconnect()
    this.unsubscribeFeatureFlags?.()
  }
}
